// What the formula editor (MathEditor.tsx) is editing, set from outside React.

export type MathTarget = {
  kind: 'inline' | 'block'
  /** The formula's position, or null for a new one at the caret. */
  pos: number | null
  latex: string
}

export class MathStore {
  private target: MathTarget | null = null
  private readonly listeners = new Set<() => void>()
  subscribe = (fn: () => void) => {
    this.listeners.add(fn)
    return () => this.listeners.delete(fn)
  }
  getSnapshot = () => this.target
  open(t: MathTarget | null) {
    this.target = t
    for (const fn of this.listeners) fn()
  }
}
